import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { useLocomotiveScroll } from "react-locomotive-scroll";
// 1. Import Link and useNavigate
import { Link, useNavigate } from "react-router-dom";

import Logo from "../assets/Svgs/star_white_48dp.svg";

// --- Styled Components ---

const Section = styled.section`
  min-height: 100vh;
  width: 100vw;
  margin: 5rem auto;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  background-color: ${(props) => props.theme.body};
  color: ${(props) => props.theme.text};

  position: relative;
`;

const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  img {
    width: 10vw;
    height: auto;
  }
  h3 {
    font-size: ${(props) => props.theme.fontxxl};
    font-family: "Kaushan Script";

    @media (max-width: 48em) {
      font-size: ${(props) => props.theme.fontxl};
    }
  }
`;

const FooterComponent = styled(motion.footer)`
  width: 80vw;

  @media (max-width: 48em) {
    width: 90vw;
  }

  ul {
    list-style: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    margin: 2rem;
    margin-top: 4rem;
    padding: 0 1rem;
    border-top: 1px solid ${(props) => props.theme.text};
    border-bottom: 1px solid ${(props) => props.theme.text};

    @media (max-width: 48em) {
      justify-content: center;
    }
  }

  li {
    padding: 2rem;
    font-size: ${(props) => props.theme.fontlg};
    text-transform: uppercase;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.1);
    }

    @media (max-width: 48em) {
      padding: 1rem;
      font-size: ${(props) => props.theme.fontmd};
    }
  }
`;

// 2. New styled component for the router Link
const StyledLink = styled(Link)`
  text-decoration: none;
  color: inherit;
`;

const Bottom = styled.div`
  padding: 0.5rem 0;
  margin: 0 4rem;
  font-size: ${(props) => props.theme.fontlg};

  display: flex;
  justify-content: space-between;
  align-items: center;
  a {
    text-decoration: underline;
  }

  @media (max-width: 64em) {
    flex-direction: column;
    justify-content: center;
    width: 100%;
    margin: 0;
    span {
      transform: none !important;
    }
  }

  @media (max-width: 48em) {
    font-size: ${(props) => props.theme.fontmd};
  }
`;

// --- Footer Component ---
const Footer = () => {
  const { scroll } = useLocomotiveScroll();
  // 3. Get the navigate function
  const navigate = useNavigate();

  // 4. Updated handleScroll function (same as in NavBar)
  const handleScroll = (id) => {
    navigate("/"); // Navigate to home page first

    // Wait for navigation to complete
    setTimeout(() => {
      let elem = document.querySelector(id);
      
      if (scroll && elem) {
        scroll.scrollTo(elem, {
          offset: "-100",
          duration: "2000",
          easing: [0.25, 0.0, 0.35, 1.0],
        });
      } else if (scroll) {
        // Fallback: If element isn't found, just go to top
        scroll.scrollTo(0);
      }
    }, 100);
  };

  return (
    <Section>
      <LogoContainer>
        <img data-scroll data-scroll-speed="2" src={Logo} alt="Wibe Studio" />
        <h3 data-scroll data-scroll-speed="-1">
          Triode Devs
        </h3>
      </LogoContainer>
      <FooterComponent
        initial={{ y: "-400px" }}
        whileInView={{ y: 0 }}
        viewport={{ once: false }}
        transition={{
          duration: 1.5,
        }}
      >
        {/* 5. UPDATED MENU ITEMS */}
        <ul>
          <li onClick={() => handleScroll("#home")}>home</li>
          <li onClick={() => handleScroll(".about")}>about</li>
          
          {/* "Shop" removed, "Projects" added */}
          <li>
            <StyledLink to="/projects">projects</StyledLink>
          </li>
          
          {/* "New Arrival" renamed */}
          <li onClick={() => handleScroll("#new-arrival")}>our projects</li>
          
          <li>
            <StyledLink to="/contact">contact</StyledLink>
          </li>
          <li>
            <a href="https://google.com" target="_blank" rel="noreferrer">
              reviews
            </a>
          </li>
        </ul>
        <Bottom>
          <span
            data-scroll
            data-scroll-speed="2"
            data-scroll-direction="horizontal"
          >
            &copy; {new Date().getFullYear()}. All Rights Reserved.
          </span>
          <span
            data-scroll
            data-scroll-speed="-2"
            data-scroll-direction="horizontal"
          >
            {/* 6. UPDATED "MADE BY" LINK */}
            Made with &hearts; by &nbsp;
            <a
              href="https://triode-portfolio.pages.dev"
              target="_blank"
              rel="noreferrer"
            >
              Triode Devs
            </a>
          </span>
        </Bottom>
      </FooterComponent>
    </Section>
  );
};

export default Footer;